export class SessionStorageUtils {
    public static setBoolean(key: string, value: boolean): void {
        sessionStorage.setItem(key, value.toString());
    }
    
    public static getBoolean(key: string): boolean {
        const value = sessionStorage.getItem(key);
        return value?.toLowerCase() === 'true';
    }
}